"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isActiveElectricitySupply = exports.isActiveSupply = void 0;
var date_fns_1 = require("date-fns");
var isActiveSupply = function (supply) {
    if (supply === null) {
        return false;
    }
    if (supply.end) {
        return !(0, date_fns_1.isBefore)(supply.end, (0, date_fns_1.subDays)(new Date(), 1));
    }
    else {
        return supply.end === null;
    }
};
exports.isActiveSupply = isActiveSupply;
var isActiveElectricitySupply = function (supply) {
    return supply.fuel === 'Electricity' && (0, exports.isActiveSupply)(supply);
};
exports.isActiveElectricitySupply = isActiveElectricitySupply;
